import { useDemoShiftControlStore } from './store'

interface InfoSlotsTrackerItem {
  text: string
  value: number | string
  highlighted: boolean
}

interface InfoSlotsTrackerReturn {
  config: ComputedRef<InfoSlotsTrackerItem[]>
}

export const useInfoSlotsTracker = (): InfoSlotsTrackerReturn => {
  const demoShiftControlStore = useDemoShiftControlStore()

  const config = computed<InfoSlotsTrackerItem[]>(() => {
    const customersWaiting = demoShiftControlStore.getCustomersWaiting
    return [
      {
        text: 'Customers waiting:',
        value: customersWaiting,
        highlighted: Number(customersWaiting) > 0,
      },
      {
        text: 'Lessons in progress:',
        value: demoShiftControlStore.getLessonsInProgress,
        highlighted: false,
      },
      {
        text: 'Tutors waiting:',
        value: demoShiftControlStore.getTutorsWaiting,
        highlighted: false,
      },
    ]
  })

  return {
    config,
  }
}
